<div class="row" >
  <div class="col-12" style="text-align:center">
    <h1>Welcome to Angular application</h1>
  </div>
</div>
